import { User, Role } from './auth.types';

export enum ColumnType {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  BOOLEAN = 'boolean',
  DROPDOWN = 'dropdown',
  REFERENCE = 'reference',
}

export enum PermissionType {
  READ = 'read',
  WRITE = 'write',
  DELETE = 'delete',
  ADMIN = 'admin',
}

// ========== Формулы ==========

export enum FormulaType {
  SET_TIMESTAMP = 'SET_TIMESTAMP',
  REGEX_EXTRACT = 'REGEX_EXTRACT',
  COPY_VALUE = 'COPY_VALUE',
  CONCAT = 'CONCAT',
  MATH = 'MATH',
  CONDITIONAL = 'CONDITIONAL',
}

export enum FormulaTrigger {
  ON_CREATE = 'ON_CREATE',
  ON_UPDATE = 'ON_UPDATE',
  ALWAYS = 'ALWAYS',
}

export interface ConditionalRule {
  column: string;
  operator: 'eq' | 'ne' | 'gt' | 'gte' | 'lt' | 'lte' | 'contains' | 'regex' | 'in' | 'empty' | 'not_empty';
  compareValue?: any;
  resultValue: any;
}

export interface ColumnFormula {
  type: FormulaType;
  sourceColumns: string[];
  trigger: FormulaTrigger;
  pattern?: string;
  groupIndex?: number;
  template?: string;
  expression?: string;
  conditions?: ConditionalRule[];
  dateFormat?: string;
  fallbackValue?: any;
  overwriteManual?: boolean;
}

// ========== Основные типы ==========

export interface TableColumn {
  id: string;
  name: string;
  description?: string;
  type: ColumnType;
  isRequired: boolean;
  isUnique: boolean;
  options?: any;
  displayOrder: number;
  tableId: string;
  formula?: ColumnFormula | null;
}

export interface DataTable {
  id: string;
  name: string;
  description?: string;
  columns: TableColumn[];
  createdAt: string;
  updatedAt: string;
}

export interface TablePermission {
  id: string;
  tableId: string;
  userId?: string;
  roleId?: string;
  permissions: PermissionType[];
  user?: User;
  role?: Role;
}